import React, { useState } from 'react';
import { X, Sparkles } from 'lucide-react';

const DemoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.1) 10px, rgba(255,255,255,0.1) 20px)'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-2.5 sm:py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <Sparkles size={16} className="text-white sm:w-[18px] sm:h-[18px]" />
            </div>
            <div className="min-w-0">
              <p className="text-xs sm:text-sm font-medium leading-tight">
                <span className="font-bold">الوضع التجريبي</span>
                <span className="hidden sm:inline"> - هذا عرض توضيحي مع منشورات مولدة بالذكاء الاصطناعي</span>
                <span className="sm:hidden"> - منشورات تجريبية فقط</span>
              </p>
              <p className="text-[10px] sm:text-xs text-white/80 mt-0.5 truncate">
                المحتوى المعروض مُعد مسبقاً. الوظائف الكاملة للذكاء الاصطناعي تتطلب إعداد الخادم.
              </p>
            </div>
          </div>

          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 p-1.5 hover:bg-white/20 rounded-full transition-colors"
            aria-label="إغلاق الشريط"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
